import { ChatConversationStatus } from '@website/types/graphqlOperations';
import { sentenceCase } from 'change-case';
import { Form, Row } from 'react-bootstrap';

type Props = {
  onFilterByStatus: (status: ChatConversationStatus) => void;
  value: ChatConversationStatus;
};

export default function FilterInboxByStatus({
  onFilterByStatus,
  value,
}: Props) {
  return (
    <>
      <Row className="mb-3">
        <Form.Group controlId="text" className="pt-2 pb-2">
          <Form.Label className="font-weight-bold">
            Filter by Conversation Status
          </Form.Label>
          <Form.Control
            value={value}
            onChange={(e) =>
              onFilterByStatus(e.target.value as ChatConversationStatus)
            }
            aria-label="Conversation Status"
            as="select"
            required
          >
            <option value={ChatConversationStatus.OPEN}>
              {sentenceCase(ChatConversationStatus.OPEN)}
            </option>
            <option value={ChatConversationStatus.WAITING_FOR_CUSTOMER_REPLY}>
              {sentenceCase(ChatConversationStatus.WAITING_FOR_CUSTOMER_REPLY)}
            </option>
            <option value={ChatConversationStatus.CLOSED}>
              {sentenceCase(ChatConversationStatus.CLOSED)}
            </option>
          </Form.Control>
        </Form.Group>
      </Row>
    </>
  );
}
